import axios from "axios";
import ApiConstants from "../Utils/ApiConstant";
import SessionManager from "../Utils/Session";

const DistrictService = {
  get: async (offset, limit, searchQuery, state_id) => {
    try {
      const response = await axios.get(
        ApiConstants.district.baseUrl +
          `?offset=${offset}&limit=${limit}&searchQuery=${searchQuery.trim()}&state_id=${
            state_id ?? ""
          }`
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  getAll: async (state_id) => {
    try {
      const response = await axios.get(
        ApiConstants.district.getAll + `?state_id=${state_id ?? ""}`
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await axios.post(
        ApiConstants.district.delete,
        {
          id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  changeStatus: async (id, status) => {
    try {
      const response = await axios.put(
        ApiConstants.district.changeStatus,
        {
          id: id,
          isActive: status,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  create: async (name, state_id) => {
    try {
      const response = await axios.post(
        ApiConstants.district.baseUrl,
        {
          name: name.trim(),
          state_id: state_id.trim(),
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },

  update: async (id, name) => {
    try {
      const response = await axios.put(
        ApiConstants.district.baseUrl,
        {
          name: name.trim(),
          id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${SessionManager.shared.getSessionToken()}`,
          },
        }
      );
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(response.error);
      }
    } catch (error) {
      throw error;
    }
  },
};

export default DistrictService;
